import { Utils } from '~core/utils/tools/utils.tools';
import { ComparisonOperatorsEnum } from './enums/comparison-operators.enum';
import { OperandTypeEnum } from './enums/operand-type.enum';

export class ColumnFilterModel {
    column!: string;
    values: any[] = [];
    comparisonOperator!: ComparisonOperatorsEnum;
    operand = OperandTypeEnum.And;

    // filter service uses this to uniquely identify filters (since else two filters can be exactly the same)
    internalId: string;

    constructor(init?: Partial<ColumnFilterModel>) {
        Object.assign(this, init);
        this.internalId = init?.internalId || Utils.newGuid();
    }
}
